export default "__VITE_ASSET__12487e2e__"